module.exports = __webpack_public_path__ + "img/back01.7e7ce52a.png";